import { useLocalStorage } from "usehooks-ts";

export function useFeedbackDismissed() {
  const values = useLocalStorage("feedback-dialog-dismissed", false);
  return values;
}
